import { render } from "./round-icon.vue?vue&type=template&id=3f100109"
import script from "./round-icon.vue?vue&type=script&lang=js"
export * from "./round-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__